import { useCallback, useEffect, useState } from 'react';
import api from './api';

export function useSubcoCompanies(enabled = true) {
  const [subcos, setSubcos] = useState([]);
  const [tags, setTags] = useState([]);
  const refresh = useCallback(async () => {
    const [a, b] = await Promise.all([
      api.get('/subco-companies').catch(() => null),
      api.get('/user-tags').catch(() => null),
    ]);
    setSubcos(a?.data?.data || []);
    setTags(b?.data?.data || []);
  }, []);
  useEffect(() => { if (enabled) refresh(); }, [enabled, refresh]);
  return { subcos, tags, setTags, refresh };
}

export const subcoInitials = (name) => (name || '?').split(/\s+/).slice(0, 2).map((s) => s[0]?.toUpperCase() || '').join('') || '?';
